import styled from "styled-components"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { QidDatapoint } from "server/models"
import { deepCopy, useInput } from "client/utils"
import {
    StoreType,
    QidDatapointChanges,
    setQidDatapointChanges,
} from "client/store"
import { Input } from "client/components"


const TableInputStyled = styled(Input)`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`

interface InputProps {
    data: string
}

const TableInput = ({
    data,
}: InputProps) => {
    const activeCell = useSelector((state: StoreType) => state.qidDatapoint.activeCell)
    const changes = useSelector((state: StoreType) => state.qidDatapoint.changes)
    const dispatch = useDispatch()

    const [value, setValue] = useInput(data || "")

    useEffect(() => {
        const input = document.querySelector(TableInputStyled) as HTMLInputElement
        input.focus()
        input.select()
    }, [])

    useEffect(() => {
        const parsedValue = parseFloat(value)
        let formattedValue: string
        if (Number.isNaN(parsedValue)) formattedValue = null
        else if (parsedValue === 0) formattedValue = "0"
        else if (parsedValue > 0) formattedValue = parsedValue.toExponential()
        else formattedValue = null

        const changesCopy: QidDatapointChanges = deepCopy(changes)
        if (!changesCopy[activeCell.datapointId]) {
            changesCopy[activeCell.datapointId] = {}
        }
        changesCopy[activeCell.datapointId] = {
            ...changesCopy[activeCell.datapointId],
            [activeCell.field as keyof QidDatapoint]: formattedValue,
        }
        dispatch(setQidDatapointChanges(changesCopy))
    }, [value])

    return (
        <TableInputStyled type="text" value={value} onChange={setValue} />
    )
}
export default TableInput
